import React from "react";
import './Blog.css';
import Banner from "../Banner/Banner";
import b1 from "../images/b1.png"
import b2 from "../images/b2.jpg"
import b3 from "../images/b3.png"
import b4 from "../images/b4.jpg"
import b5 from "../images/b5.jpg"
import b6 from "../images/b6.png"
import b7 from "../images/b7.jpg"
import b8 from "../images/b8.png"
import b9 from "../images/b9.jpg"
import { Link } from "react-router-dom";


export function Blog(){

    return(
        <div className="blog">
            <div className="container">
                <div className="cards">
                    <div className="card">
                        <img src={b1} />
                        <div className="discribtion">
                            <h5>John deo </h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Dental Care for Women is very important</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b2} />
                        <div className="discribtion">
                            <h5>Peter Packer</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>In this hospital there are special surgeon</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b3} />
                        <div className="discribtion">
                            <h5>Sonar Moyna</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Why Is Skin Surgeon Considered Underrated</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b4} />
                        <div className="discribtion">
                            <h5>Kalina</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Understand Health Before You Regret</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b5} />
                        <div className="discribtion">
                            <h5>Michel</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Health Will Be A Thing Of The Past And Here</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b6} />
                        <div className="discribtion">
                            <h5>Peter Packer</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Can you get a diflucan prescription online?</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b7} />
                        <div className="discribtion">
                            <h5>Sonar Moyna</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Ten Gigantic Influences Of Health</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b8} />
                        <div className="discribtion">
                            <h5>Kalina</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Why Is Skin Surgeon Considered Underrated</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                    <div className="card">
                        <img src={b9} />
                        <div className="discribtion">
                            <h5>Sara</h5>
                            <h5><i class="fa-regular fa-calendar-days"></i></h5>
                            <h5> 19 July 2025</h5>
                        </div>
                        <h3>Everyone need to go Dentist regularly</h3>
                        <Link to="/blog"><button>Read More<span><i className="fa-solid fa-chevron-right"></i></span></button></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
function blog(){

    return(
        <>
            <Banner title="Blog" smtitle="blog"/>
            <Blog/>
        </>
    )
}
export default blog;